import { useCallback } from "react";
import { ArrowCounterClockwiseIcon, TrashSimpleIcon } from "@phosphor-icons/react";

import { ICON_SIZE } from "@/config/constants";
import { NoteAction } from "@/features/notes/types";
import { FetchedNote } from "@/services/api/fetchers/notes";

interface UseNotesTrashActionsProps {
  deleteNote: (id: number) => void;
  restoreNote: (id: number) => void;
}

export function useNotesTrashActions({ deleteNote, restoreNote }: UseNotesTrashActionsProps) {
  const actions = useCallback(
    (note: FetchedNote) => {
      const actions: NoteAction[] = [
        {
          key: "restore",
          label: "Restore",
          icon: <ArrowCounterClockwiseIcon size={ICON_SIZE.sm} />,
          run: () => {
            restoreNote(note.id);
          },
        },
        {
          key: "delete",
          label: "Delete forever",
          icon: <TrashSimpleIcon size={ICON_SIZE.sm} />,
          run: () => deleteNote(note.id),
        },
      ];

      return actions;
    },
    [deleteNote, restoreNote]
  );

  return actions;
}
